module.exports = __webpack_public_path__ + "img/28773b7.png";